import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.MktAndCommView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'marketing-and-communication'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/mkt_and_comm"]
  legendsTemplate: JST["backbone/templates/monitoring/reports/executive/hierarchy_legends"]

  initialize: (@options = {}) ->
    @colors = @options.colors
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @tags = @options.settings.mktAndCommTags

  render: ->
    @$el.html(@template(brand: @options.settings.accountLabel.codes[0]))
    @bindChartsReady(3)
    @addLabelsPie()
    @addSentimentPie()
    @addHistogram()
    return this

  addLabelsPie: ->
    query = @extendedQuery({ dimension: 'filtered_tags', tags: @tags, labels: @options.settings.accountLabel.codes })
    divId = "#marketing-pie"
    legendId = "#marketing-labels"
    callback = (response) => @addLabels(response, legendId)
    @_addPie(query, divId, { callback: callback, prepareColors: @prepareColors, drillDownFunction: (clickEvent) ->
      {
        tags: [clickEvent.point.code],
      }
    } )

  addLabels: (response, divId) =>
    legends = []
    series = response.series
    color = @options.settings.customColors.length
    total = series[0].data.reduce ((total, point) -> total + point.y), 0
    for point, index in series[0].data
      if point.y > 0
        color = @colors[point.code] || @colors[point.name] || @options.settings.customColors[index % color_count]
        legends.push {
          tag: point.name
          value: point.y + " (" + (point.y / total * 100).toFixed(2) + "%)"
          index: index+1
          color: color
        }
    $legend = $(@legendsTemplate(legends: legends)).addClass('references')
    @$el.find(divId).append($legend)

  addHistogram: ->
    query = @extendedQuery({
      dimension: 'sentiment'
      labels: @options.settings.accountLabel.codes
      labels_structure: @labelsStructure()
      tags: @tags
    })
    @_addHistogram(query,'#marketing-ugc-histogram', { drillDownFunction: (clickEvent) =>
      from = new Date(clickEvent.point.x)
      to = new Date(clickEvent.point.x + clickEvent.point.series.pointInterval)
      {
        date_from: @_formatDate(from)
        date_from_ISO: from.toISOString()
        date_to: @_formatDate(to)
        date_to_ISO: to.toISOString()
        sentiment: [clickEvent.point.series.name.toLowerCase()],
        tags: @tags
      }
    } )

  addSentimentPie: ->
    query = @extendedQuery({dimension: 'sentiment', tags: @tags, labels: @options.settings.accountLabel.codes })
    divId = "#marketing-sentiment"
    legendId = "#marketing-sentiment-labels"
    callback = (response) => @addLabels(response, legendId)
    @_addPie(query, divId, { callback: callback, prepareColors: @prepareColors, drillDownFunction: (clickEvent) =>
      {
        sentiment: [clickEvent.point.code],
        tags: @tags
      }
    } )
